<template>
  <div>
    <v-menu offset-y top left :nudge-left="10" :close-on-content-click="true">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" x-small>
          <v-icon small> mdi-paperclip </v-icon>
        </v-btn>
      </template>

      <v-list class="attachment-menu">
        <v-list-item
          v-for="(attachment, index) in attachments"
          :key="index"
          class="attachment-item"
          @click="selectAttachment(attachment.value)"
        >
          <div class="attachment-content">
            <v-icon small :color="attachment.color">
              {{ attachment.icon }}
            </v-icon>

            <span>
              {{ attachment.text }}
            </span>
          </div>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Images and videos -->
    <input
      ref="imageInput"
      type="file"
      accept="image/*,video/*"
      hidden
      @change="onFilesSelected($event, 'MEDIA')"
    />

    <!-- Vidéos -->
    <input
      ref="videoInput"
      type="file"
      accept="video/*"
      hidden
      @change="onFilesSelected($event, 'VIDEO')"
    />

    <!-- Documents -->
    <input
      ref="documentInput"
      type="file"
      accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
      hidden
      @change="onFilesSelected($event, 'DOCUMENT')"
    />

    <!-- Audio -->
    <input
      ref="audioInput"
      type="file"
      accept="audio/*"
      hidden
      @change="onFilesSelected($event, 'AUDIO')"
    />

    <!-- Sticker -->
    <input
      ref="stickerInput"
      type="file"
      accept="image/*"
      hidden
      @change="onFilesSelected($event, 'STICKER')"
    />
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  data() {
    return {
      attachments: [
        {
          text: this.$i18n.t("chat.messages.type.media"),
          value: "MEDIA",
          color: "#1683FF",
          icon: "mdi-image",
        },
        {
          text: this.$i18n.t("chat.messages.type.file"),
          value: "DOCUMENT",
          color: "#5B6FF5",
          icon: "mdi-file-document",
        },
        /*  {
          text: this.$i18n.t("chat.messages.type.video"),
          value: "VIDEO",
          color: "#1683FF",
          icon: "mdi-video",
        }, */
        {
          text: this.$i18n.t("chat.messages.type.audio"),
          value: "AUDIO",
          color: "#FF4A1C",
          icon: "mdi-headphones",
        },
        {
          text: this.$i18n.t("chat.messages.type.sticker"),
          value: "STICKER",
          color: "#00C853",
          icon: "mdi-sticker-plus",
        },
      ],
    };
  },

  methods: {
    selectAttachment(type) {
      switch (type) {
        case "MEDIA":
          this.$refs.imageInput.click();
          break;

        case "VIDEO":
          this.$refs.videoInput.click();
          break;

        case "DOCUMENT":
          this.$refs.documentInput.click();
          break;

        case "AUDIO":
          this.$refs.audioInput.click();
          break;

        case "STICKER":
          this.$refs.stickerInput.click();
          break;
      }
    },
    onFilesSelected(event, type) {
      
      const files = Array.from(event.target.files);
      if (!files.length) {
        return;
      }

      const allowedTypes = {
        MEDIA: (file) =>
          file.type.startsWith("image/") || file.type.startsWith("video/"),

        VIDEO: (file) => file.type.startsWith("video/"),

        DOCUMENT: (file) =>
          [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "text/plain",
          ].includes(file.type),

        AUDIO: (file) => file.type.startsWith("audio/"),

        STICKER: (file) => file.type.startsWith("image/"),
      };

      const validator = allowedTypes[type];

      if (!validator) {
        event.target.value = "";
        return;
      }

      const validFiles = files.filter(validator);

      if (!validFiles.length) {
        event.target.value = "";
        return;
      }

      let eventType = type;

      if (type === "MEDIA") {
        const hasImage = validFiles.some((file) =>
          file.type.startsWith("image/"),
        );

        const hasVideo = validFiles.some((file) =>
          file.type.startsWith("video/"),
        );

        if (hasImage && hasVideo) {
          event.target.value = "";
          return;
        }

        if (hasImage) {
          eventType = "IMAGE";
        } else if (hasVideo) {
          eventType = "VIDEO";
        }
      }
      this.$emit("add-media", {
        type: eventType,
        files: validFiles,
      });

      event.target.value = "";
    },
  },
};
</script>

<style scoped></style>
